// 新增物料
import { useEffect, useReducer } from 'react'
import { Button, message, Form, Skeleton, Space, Divider } from 'antd'
import Maininfo from '../../modules/goodsdetailmodules/maininfo'
import Uploadimg from '../../modules/goodsdetailmodules/uploadimg'
import AptitudeAttach from '../../modules/goodsdetailmodules/AptitudeAttach'
import Style from './goodsmanage.module.scss'
import {
  ADD_PRODUCTCHILD,
  CACHE_PRODUCT,
  GET_PRODUCT_CACHE,
} from '../../api/MaterialApi'
import { history, useTypedSelector } from '../../redux/store'
import { reportProjectCategoryAdoptions } from '@/tools/projectCategoryAdopt'
import { useDispatch } from 'react-redux'
import { ProductChildParams } from '../../api/Params'
import {
  setformStateInitAction,
  setformStateAction,
} from '../../modules/ControlformState'
import { useLocation } from 'react-router-dom'
import { setModuleDataAction } from '../../modules/pagecache'
import CustomModal from '../../components/ModalUser'
import Record from './components/record'
import useHook from './hook'
import Originalpic from '../../modules/goodsdetailmodules/originalpic'
import { RoleType } from '../../tools/util'
import Mainpic from '../../modules/goodsdetailmodules/mainpic'
import Secondaryinfo from '../../modules/goodsdetailmodules/secondaryinfo'
import Expandattr from '../../modules/goodsdetailmodules/expandattr'
import MaterialType from '../../modules/goodsdetailmodules/materialType'
import AssociationItems from '../../modules/goodsdetailmodules/associationItems'
import ShibeiModal from './components/ShiBeiModal/ShibeiModal'
import {
  materialTypeEnum,
  preReviewOfMaterialsTypeEnum,
} from '../../global/enum/product'
import { SUPROUTE } from '../../route'
import ExternalLink, {
  ExternalLinkType,
  toExternalLinkPayload,
} from '@/modules/goodsdetailmodules/externallink'
import { usePreCheck } from '@/hooks/usePreCheck'

const ACTION_TYPE = {
  SET_CURRENT_PARAM: 'set_current_param', // 设置当前页面参数
  CHANGE_DATA: 'CHANGE_DATA', // 替换所有状态
  CHANGE_LOADING: 'CHANGE_LOADING',
}
interface State {
  // 当前参数
  currentparam: nowpagesparam
  isloading: boolean
}
interface nowpagesparam {
  tempId?: string // 暂存商品 id
  childId?: string // 子商品 id
  // 选中的tree层级
  selectTreeData?: treeType
  BtnState?: MaterialDetailType[] // 模块状态
}
export interface treeType {
  id: string // 树 id
  title: string // 树名称
  level: string // 树层级
  parentId?: string // 父级id
}
const defaultState: State = {
  currentparam: {},
  isloading: false,
}
const reducer = (state: State, action: { type: string; value?: any }) => {
  let arr = { ...state }
  switch (action.type) {
    case ACTION_TYPE.SET_CURRENT_PARAM:
      arr.currentparam = action.value
      return arr
    case ACTION_TYPE.CHANGE_DATA:
      arr = action.value
      return arr
    case ACTION_TYPE.CHANGE_LOADING:
      arr.isloading = action.value
      return arr
    default:
      return { ...state }
  }
}

// 设置当前页面参数
const setChangeLoading = (params: boolean) => ({
  type: ACTION_TYPE.CHANGE_LOADING,
  value: params,
})

// 重新加载数据
const reloadDataAction = (params: State) => ({
  type: ACTION_TYPE.CHANGE_DATA,
  value: params,
})

// 新增物料默认 表单数据
const defaultFormData = {
  code: '提交后自动生成',
  level: '2', // 物料等级
  rulestype: 'PHBM001', // 批号规则
  rulestypeName: '万聚默认批号规则', // 批号规则 名称
  taxtype: 'WLDSFL01_SYS', // 税分类
  taxtypeName: '标准税率', // 税分类 名称
  invencategory: 'CHLB01_SYS', // 存货类别
  invencategoryName: '原材料', // 存货类别 名称
  defaulttax: 'SL02_SYS', // 默认税率
  defaulttaxName: '13%增值税', // 默认税率 名称
  materialattr: '1', // 物料属性
  materialattrName: '外购', // 物料属性 名称
  currency: 'PRE001', // 币别
  batchmanage: '1', // 批号管理
  assets: '0', // 允许资产
  onlocklib: '1', // 允许锁库
  onreturn: '1', // 允许退货
  onreturnmaterial: '1', // 允许退料
  product: '0', // 允许生产
  canBeMainProduct: '0', // 可为主产品  默认否
  allowprocurement: '1', // 允许采购
  inventory: '1', // 允许库存
  sales: '1', // 允许销售
  outcommit: '0', // 允许委外
  pricestate: '1', // 影响价格
  coststate: '1', // 影响成本
  mallsales: '0', // 商城可售
  onshelf: '1', // 商城上架
  isFreeShipping: '1', // 包邮
  isOverLength: '0', // 超长
  // picMatch: `1`, // 图片匹配度
  deliveryday: '', // 发货日
  deliveryDate: '',
  orderQuantity: '', // 起订量
}

// 路由参数
interface RouteParam extends nowpagesparam {
  init?: boolean // 是否初始化
  copydata?: any // copy
  type?: string
}

const Goodsdetail = () => {
  const {
    usehookstate,
    form,
    platform_form,
    changeList,
    setChangeList,
    onChangePic,
    onChangeAptitude,
    onChangeDetailPic,
    onChangeCate,
    onChangeBrandSale,
    onClickClose,
    onCancelrecord,
    getformatFormFields,
    reloaddata,
    tempCode,
    onChangeDelivery,
    getTempCode,
    setMaterialType,
    onChangeMaterialType,
    changeItemList,
    handleOpenExtractModal,
    closeExtractModal,
    onFieldsChange,
    externalLinkList,
    setExternalLinkList,
    setQualityDataList,
    checkProductForbidChar,
    checkTaxCodeBlacklist,
    setPreCheckErrors,
    setReportFieldConfigList,
    relateFieldKeySet,
    handleRelateFieldBlur,
  } = useHook()
  const [pagesstate, dispatch] = useReducer(reducer, defaultState)
  const dispatchRedux = useDispatch()
  const {
    pictures,
    qualDocFileList,
    requiredAttachTypes,
    frontendHintText,
    detailPic,
    productCode,
    fieldList,
    isRecord,
    loadingPage,
    hasDelivery,
    unitDisabled,
    materialType,
    itemsList,
    qualityDataList,
    preCheckErrors,
  } = usehookstate
  const { isloading } = pagesstate
  const { tempId, childId } = pagesstate.currentparam
  const { role, cooperateType } = useTypedSelector((state) => state.authtoken)
  const { pagekey } = useTypedSelector((state) => state.pageCache)
  const location = useLocation<RouteParam>()

  const { state } = location

  useEffect(() => {
    const flag = getpagecache()
    if (flag && !state) {
      // 读取缓存的公共模块状态
      reloaddata(flag.commonState)
      // 设置form数据
      form.setFieldsValue(flag.formState)
      // 读取缓存的当前模块状态
      dispatch(reloadDataAction(flag.pageState))
      // 判断物料属性
      materialattrDisabled(flag.pageState.currentparam.BtnState)
    } else if (state) {
      // 初始化 formstate
      dispatchRedux(setformStateInitAction())
      materialattrDisabled(state.BtnState)
      if (state.type === 'copy') {
        return
      }
      // 新增物料
      if (!tempId && !childId) {
        isAddMethod(state.selectTreeData)
        GET_PRODUCT_CACHE().then((res) => {
          getTempCode()
          if (res.code == 0) {
            if (res.data?.content) {
              const data = JSON.parse(res.data?.content)
              if (!data.pageState) {
                return
              }
              reloaddata(data.pageState)
              setChangeList(!changeList)
              form.setFieldsValue(data.formData)
              platform_form.setFieldsValue(data.platformForm)
              setExternalLinkList(data.externalLinks || [])
            }
          }
        })
      }
      if (state.BtnState?.includes('Add')) {
        // 新增物料，物料类型取默认值
        setMaterialType(cooperateType === '3' ? '2' : cooperateType)
      }
      form.setFieldsValue({ childId: state.childId }) // 设置物料id 如果为新增则是空 用于maininfo页面判断
    }
    // eslint-disable-next-line
  }, [])

  useEffect(() => {
    // 缓存存数据
    const pathName = history.location.pathname + 'goodsDetail'
    const formstate = form.getFieldsValue()
    const action = setModuleDataAction({
      key: pathName,
      data: {
        commonState: usehookstate, // 公共状态
        pageState: pagesstate, // 当前状态
        formState: formstate,
      },
    })
    dispatchRedux(action)
    return () => {
      const formstate = form.getFieldsValue()
      const action = setModuleDataAction({
        key: pathName,
        data: {
          commonState: usehookstate, // 公共状态
          pageState: pagesstate, // 当前状态
          formState: formstate,
        },
      })
      dispatchRedux(action)
    }
    // eslint-disable-next-line
  }, [usehookstate, pagesstate])

  const handleLinkChange = (newList: ExternalLinkType[]) => {
    setExternalLinkList(newList)
  }

  // 获取数据
  const getpagecache = () => {
    const pathName = history.location.pathname + 'goodsDetail'
    const data = pagekey.filter((item) => item.key === pathName)
    if (data.length === 1) {
      return data[0].data
    }
    return null
  }

  // 物料属性是否可修改
  const materialattrDisabled = (params?: MaterialDetailType[]) => {
    let flag = false
    if (role === RoleType.SOURCE_PURCHASE_MAN && params) {
      // 采购员 物料属性
      flag = params.indexOf('Add') !== -1 ? false : true
    }
    dispatchRedux(setformStateAction([{ key: 'materialattr', disabled: flag }]))
  }

  // 是否 添加物料方法
  async function isAddMethod(cate?: treeType) {
    // 有类目id 设置前缀编码 和 扩展属性
    if (cate) {
      onChangeCate(cate.id)
      // 设置类目id和名称
      form.setFieldsValue({
        catoyName: cate.title,
        catoyid: cate.id,
      })
    }

    dispatchRedux(
      setformStateAction([{ key: 'catoyid', hidden: false, disabled: false }]),
    )
    // 设置货主 物料默认数据
    form.setFieldsValue({
      ...defaultFormData,
    })
  }

  // 提交数据 立即提交 暂存
  async function preCheckSubmit(params: ProductChildParams) {
    setPreCheckErrors({})
    // 使用预审 Hook 处理提交逻辑
    await executePreCheck(
      params,
      preReviewOfMaterialsTypeEnum.getValueByLabel('新增物料') || '',
    )
  }
  // 使用预审 Hook
  const { executePreCheck, PreCheckModalComponent } = usePreCheck({
    form,
    onSubmit: onCommit,
    onModify: (errors) => {
      if (Number(errors.sugMallPrice) > 0 && itemsList.length > 0) {
        const mallFieldKey = itemsList[0].itemFields.find(
          (item) => item?.fieldMeaning === 'mallPrice',
        )?.fieldKey
        if (mallFieldKey) {
          platform_form.setFieldsValue({
            [`${itemsList[0].code}_${mallFieldKey}`]: errors.sugMallPrice,
          })
        }
      }
      setPreCheckErrors(errors)
    },
  })

  // 提交新增物料 暂存物料提交 数据
  async function onSubmmit(operateType: string) {
    try {
      // 格式化表单数据
      const values = await getformatFormFields()
      const canPassForbidCharCheck = await checkProductForbidChar(values)
      if (!canPassForbidCharCheck) {
        return
      }

      // 提交前校验税编是否命中当前货主的黑名单。货主由 MPM 按物料类型推导，
      // 这里只把 productType 传过去，不在前端算货主，避免两端口径走偏
      const canPassBlacklistCheck = await checkTaxCodeBlacklist(
        values.productType,
        values.taxCategoryCode,
      )
      if (!canPassBlacklistCheck) {
        return
      }

      if (
        !itemsList.length &&
        materialTypeEnum.getLabelByValue(values.productType) ===
          '电商供应商物料'
      ) {
        message.error('电商供应商物料至少添加一个关联项目')
        return
      }
      const params: any = {
        ...values,
        tempCode: tempCode, // 临时CODE
        saveType: operateType, // 必须 操作类型；1、提交 2、暂存
        productMdmId: '',
        externalLinks: toExternalLinkPayload(externalLinkList),
      }
      if ((!childId && !tempId) || (tempId && !childId)) {
        // 校验品牌型号问题
        preCheckSubmit(params)
      } else {
        // 直接提交
        preCheckSubmit(params)
      }
    } catch (errorInfo) {
      const errorFields = (errorInfo as any)?.errorFields
      const error = errorFields?.[0]?.errors?.[0]
      console.error(errorInfo)
      if (errorFields && error) {
        message.warning(error)
        const errorname = errorFields?.[0]?.name
        // 返回报错信息，滚动到第一个报错的位置
        form.scrollToField(errorname?.toString(), { behavior: 'smooth' })
      }
    }
  }

  // 实际提交物料的函数
  async function onCommit(params: ProductChildParams) {
    dispatch(setChangeLoading(true))
    const msg = '提交中'
    message.loading(msg, 0)
    const resData = await ADD_PRODUCTCHILD(params)
    dispatch(setChangeLoading(false))
    if (resData.code === 0) {
      if (childId) {
        message.success('已提交')
      } else {
        message.success('已成功')
      }
      reportProjectCategoryAdoptions()
      // 关闭弹窗，回退路由
      onClickClose(history.location.pathname + 'goodsDetail')
      history.push({
        pathname: `${SUPROUTE}/submitResult`,
        state: {
          data: [params],
        },
      })
    } else {
      message.destroy()
    }
  }

  // 点击保存
  async function onSave() {
    try {
      // 格式化表单数据
      const values = form.getFieldsValue()
      const platformForm = platform_form.getFieldsValue()
      message.loading('保存中', 0)
      const resData = await CACHE_PRODUCT({
        formData: values,
        platformForm,
        pageState: usehookstate,
        externalLinks: toExternalLinkPayload(externalLinkList),
      })
      if (resData.code === 0) {
        if (childId) {
          message.success('已提交')
        } else {
          message.success('已成功')
        }
        reportProjectCategoryAdoptions()
        // 关闭页面，回退路由
        onClickClose()
      } else {
        message.destroy()
      }
    } catch (errorInfo) {
      const error = (errorInfo as any).errorFields[0].errors[0]
      message.warning(error)
      const errorname = (errorInfo as any).errorFields[0].name
      // 返回报错信息，滚动到第一个报错的位置
      form.scrollToField(errorname.toString(), { behavior: 'smooth' })
    }
  }

  // 按钮类型
  const ButtonComponents = () => {
    let EditBtn = null
    EditBtn = (
      <Button
        type="link"
        size="small"
        loading={isloading}
        onClick={() => onSubmmit('1')}
      >
        提交
      </Button>
    )
    return (
      <div className={Style.btnbox}>
        <div className={Style['btn-left-box']}></div>
        <div className={Style['btn-center-box']}></div>
        <div className={Style['btn-right-box']}>
          <Space>
            <Button type="link" size="small" onClick={onSave}>
              保存
            </Button>
            {EditBtn}
            <Button type="link" size="small" onClick={onClickClose}>
              关闭
            </Button>
          </Space>
        </div>
      </div>
    )
  }

  return (
    <Form.Provider>
      <ButtonComponents />
      <div className={Style.container}>
        <div className={Style.box}>
          <Skeleton loading={loadingPage} active>
            <MaterialType
              form={form}
              setMaterialType={setMaterialType}
              onChange={onChangeMaterialType}
              type="single"
              onFieldsChange={onFieldsChange}
            />
          </Skeleton>
        </div>
        <div className={Style.box}>
          <div
            className={Style.boxtitle}
            style={{ display: 'flex', justifyContent: 'space-between' }}
          >
            <span>主要信息</span>
            <span
              style={{
                display: 'inline-block',
                marginRight: '24px',
                fontWeight: 'normal',
                color: '#3C44D3',
                cursor: 'pointer',
                userSelect: 'none',
              }}
              onClick={() => handleOpenExtractModal('extract')}
            >
              🔥快捷拾取
            </span>
          </div>
          <Divider style={{ margin: '0' }} />
          <Skeleton loading={loadingPage} active>
            <Maininfo
              form={form}
              onChangeCate={onChangeCate}
              onChangeSale={onChangeBrandSale}
              tempCode={tempCode}
              showUnitTip
              unitDisabled={unitDisabled}
              getTempCode={getTempCode}
              materialType={materialType}
              onFieldsChange={onFieldsChange}
              preCheckErrors={preCheckErrors}
            />
          </Skeleton>
        </div>
        <div className={Style.box}>
          <div className={Style.boxtitle}>
            <span>次要信息</span>
          </div>
          <Divider style={{ margin: '0' }} />
          <Skeleton loading={loadingPage} active>
            <Secondaryinfo
              form={form}
              onChangeDelivery={onChangeDelivery}
              hasDelivery={hasDelivery}
              onFieldsChange={onFieldsChange}
            />
          </Skeleton>
        </div>
        {(materialType === '1' || materialType === '2') && (
          <div className={Style.box}>
            <div className={Style.boxtitle}>
              <span>关联项目信息</span>
              {materialTypeEnum.getLabelByValue(
                form.getFieldValue('productType'),
              ) === '电商供应商物料' && (
                <span style={{ color: '#ff4d4f', marginLeft: 10 }}>
                  * 请至少添加一个关联项目
                </span>
              )}
            </div>
            <Divider style={{ margin: '0' }} />
            <Skeleton loading={loadingPage} active>
              <AssociationItems
                form={platform_form}
                normalForm={form}
                itemsList={itemsList}
                changeItemList={changeItemList}
                changeList={changeList}
                onFieldsChange={onFieldsChange}
                qualityDataList={qualityDataList}
                setQualityDataListAction={setQualityDataList}
                preCheckErrors={preCheckErrors}
                reportingType="NEW"
                onReportConfigChange={setReportFieldConfigList}
                relateFieldKeySet={relateFieldKeySet}
                onRelateFieldBlur={handleRelateFieldBlur}
              />
            </Skeleton>
          </div>
        )}
        <div className={Style.box}>
          <div className={Style.boxtitle}>
            <span>拓展属性</span>
            <span className={Style.tips}>
              拓展属性标题为<span className={Style.blueTip}>蓝色</span>
              代表有平台项目对该拓展属性有要求，鼠标移到拓展属性标题即可查看具体平台项目。
              <span
                style={{
                  color: '#8C8C8C',
                  fontSize: '12px',
                  lineHeight: '24px',
                }}
              >
                都需填写，无法填写的填/【如果是大批量无法填写，可能是四级类目选错】
              </span>
            </span>
          </div>
          <Divider style={{ margin: '0' }} />
          <Skeleton loading={loadingPage} active>
            <Expandattr
              form={form}
              fieldList={fieldList}
              itemsList={itemsList}
              frontendHintText={frontendHintText}
              onFieldsChange={onFieldsChange}
            />
          </Skeleton>
        </div>
        <div className={Style.box}>
          <Divider style={{ margin: '0' }} />
          <AptitudeAttach
            dataSource={qualDocFileList}
            onChange={onChangeAptitude}
            productCode={productCode}
            loading={loadingPage}
            requiredAttachTypes={requiredAttachTypes}
          />
        </div>
        <div className={Style.box}>
          <div className={Style.boxtitle}>
            <span>外部链接/价格佐证</span>
          </div>
          <Divider style={{ margin: '0' }} />
          <Skeleton loading={loadingPage} active>
            <ExternalLink
              form={form}
              externalLinkList={externalLinkList}
              onLinkChange={handleLinkChange}
            />
          </Skeleton>
        </div>
        <div className={Style.box}>
          <div className={Style.boxtitle}>
            <span>图文信息</span>
            <span
              style={{
                display: 'inline-block',
                margin: ' 0 24px',
                fontWeight: 'normal',
                color: '#3C44D3',
                cursor: 'pointer',
                userSelect: 'none',
              }}
              onClick={() => handleOpenExtractModal('pic')}
            >
              🔥链接取图
            </span>
            <span>支持类型：.bmp|\.gif|\.jpg|\.png|\.webp|\.heic</span>
          </div>
          <Divider style={{ margin: '0' }} />
          <Skeleton loading={loadingPage} active>
            <div className={Style.picinfobox}>
              {/* <div className={Style.picinfotitle}>
                <span className={Style.text}>图片关系</span>
              </div> */}
              {/* true 显示 匹配、类似 注意必填校验 */}
              <Mainpic required form={form} onFieldsChange={onFieldsChange} />
              <div className={Style.picinfotitle}>
                <span className={Style.text}>
                  主图：
                  <span
                    style={{
                      color: '#8C8C8C',
                      fontSize: '14px',
                      lineHeight: '24px',
                    }}
                  >
                    尺寸：800×800 px。建议上传3张及以上，最多20张。第一张白底，其它尽量白底。主图要求颜色唯一，需要与描述或者拓展属性值一致【最低标准∶不低于在其他平台上架的标准】
                  </span>
                </span>
              </div>
              {preCheckErrors?.picturesError && (
                <div
                  style={{
                    color: '#FF7D00',
                    fontSize: '14px',
                    lineHeight: '24px',
                  }}
                >
                  {preCheckErrors?.picturesError}
                </div>
              )}
              <Uploadimg
                dataSource={pictures}
                onChange={onChangePic}
                tempCode={tempCode}
                maxCount={20}
                fileType={'.bmp,.gif,.jpg,.png,.webp,.heic'}
                dragable
                aiEdit
              />
              {/* true 显示 可用、不可用 注意必填校验 */}
              <div hidden>
                <Originalpic
                  required={false}
                  form={form}
                  onFieldsChange={onFieldsChange}
                />
              </div>
              <div className={Style.picinfotitle}>
                <span className={Style.text}>
                  详情图：
                  <span
                    style={{
                      color: '#8C8C8C',
                      fontSize: '12px',
                      lineHeight: '24px',
                    }}
                  >
                    上传图片宽度不小于500 px，高度不限，最多100张。要图文丰富，需包含产品图、细节图、参数图、使用场景图，【最低标准:不低于在其他平台上架的标准】。一定不能包含:7天无理由退换货、送货上门、免费开票、水印、其它店铺信息、质保、包邮、链接、二维码、电话号码......等敏感词汇
                  </span>
                </span>
              </div>
              {preCheckErrors?.detailsPicturesError && (
                <div
                  style={{
                    color: '#FF7D00',
                    fontSize: '14px',
                    lineHeight: '24px',
                  }}
                >
                  {preCheckErrors?.detailsPicturesError}
                </div>
              )}
              <Uploadimg
                dataSource={detailPic}
                onChange={onChangeDetailPic}
                tempCode={tempCode}
                isDetailPic
                fileType={'.bmp,.gif,.jpg,.png,.webp,.heic'}
                maxCount={100}
                dragable
                aiEdit
              />
            </div>
          </Skeleton>
        </div>

        <CustomModal
          title="操作记录"
          open={isRecord}
          modalCancel={onCancelrecord}
          footer={false}
        >
          <Record type={1} id={childId} />
        </CustomModal>
      </div>
      {/* 拾贝快捷拾取弹框 */}
      <ShibeiModal
        form={form}
        hookstate={usehookstate}
        onChangePic={onChangePic}
        onChangeDetailPic={onChangeDetailPic}
        closeExtractModal={closeExtractModal}
      ></ShibeiModal>
      {/* 物料预审弹框 */}
      {PreCheckModalComponent}
    </Form.Provider>
  )
}

export default Goodsdetail

type MaterialDetailType =
  // 新增
  | 'Add'
  // 编辑
  | 'Edit'
  // 详情
  | 'Detail'
  // 禁用
  | 'Disable'
  // 启用
  | 'Undisable'
  // 复制
  | 'Copy'
// 新增物料
import { useEffect, useReducer } from 'react'
import { Button, message, Form, Skeleton, Space, Divider } from 'antd'
import Maininfo from '../../modules/goodsdetailmodules/maininfo'
import Uploadimg from '../../modules/goodsdetailmodules/uploadimg'
import AptitudeAttach from '../../modules/goodsdetailmodules/AptitudeAttach'
import Style from './goodsmanage.module.scss'
import {
  ADD_PRODUCTCHILD,
  CACHE_PRODUCT,
  GET_PRODUCT_CACHE,
} from '../../api/MaterialApi'
import { history, useTypedSelector } from '../../redux/store'
import { reportProjectCategoryAdoptions } from '@/tools/projectCategoryAdopt'
import { useDispatch } from 'react-redux'
import { ProductChildParams } from '../../api/Params'
import {
  setformStateInitAction,
  setformStateAction,
} from '../../modules/ControlformState'
import { useLocation } from 'react-router-dom'
import { setModuleDataAction } from '../../modules/pagecache'
import CustomModal from '../../components/ModalUser'
import Record from './components/record'
import useHook from './hook'
import Originalpic from '../../modules/goodsdetailmodules/originalpic'
import { RoleType } from '../../tools/util'
import Mainpic from '../../modules/goodsdetailmodules/mainpic'
import Secondaryinfo from '../../modules/goodsdetailmodules/secondaryinfo'
import Expandattr from '../../modules/goodsdetailmodules/expandattr'
import MaterialType from '../../modules/goodsdetailmodules/materialType'
import AssociationItems from '../../modules/goodsdetailmodules/associationItems'
import ShibeiModal from './components/ShiBeiModal/ShibeiModal'
import {
  materialTypeEnum,
  preReviewOfMaterialsTypeEnum,
} from '../../global/enum/product'
import { SUPROUTE } from '../../route'
import ExternalLink, {
  ExternalLinkType,
  toExternalLinkPayload,
} from '@/modules/goodsdetailmodules/externallink'
import { usePreCheck } from '@/hooks/usePreCheck'

const ACTION_TYPE = {
  SET_CURRENT_PARAM: 'set_current_param', // 设置当前页面参数
  CHANGE_DATA: 'CHANGE_DATA', // 替换所有状态
  CHANGE_LOADING: 'CHANGE_LOADING',
}
interface State {
  // 当前参数
  currentparam: nowpagesparam
  isloading: boolean
}
interface nowpagesparam {
  tempId?: string // 暂存商品 id
  childId?: string // 子商品 id
  // 选中的tree层级
  selectTreeData?: treeType
  BtnState?: MaterialDetailType[] // 模块状态
}
export interface treeType {
  id: string // 树 id
  title: string // 树名称
  level: string // 树层级
  parentId?: string // 父级id
}
const defaultState: State = {
  currentparam: {},
  isloading: false,
}
const reducer = (state: State, action: { type: string; value?: any }) => {
  let arr = { ...state }
  switch (action.type) {
    case ACTION_TYPE.SET_CURRENT_PARAM:
      arr.currentparam = action.value
      return arr
    case ACTION_TYPE.CHANGE_DATA:
      arr = action.value
      return arr
    case ACTION_TYPE.CHANGE_LOADING:
      arr.isloading = action.value
      return arr
    default:
      return { ...state }
  }
}

// 设置当前页面参数
const setChangeLoading = (params: boolean) => ({
  type: ACTION_TYPE.CHANGE_LOADING,
  value: params,
})

// 重新加载数据
const reloadDataAction = (params: State) => ({
  type: ACTION_TYPE.CHANGE_DATA,
  value: params,
})

// 新增物料默认 表单数据
const defaultFormData = {
  code: '提交后自动生成',
  level: '2', // 物料等级
  rulestype: 'PHBM001', // 批号规则
  rulestypeName: '万聚默认批号规则', // 批号规则 名称
  taxtype: 'WLDSFL01_SYS', // 税分类
  taxtypeName: '标准税率', // 税分类 名称
  invencategory: 'CHLB01_SYS', // 存货类别
  invencategoryName: '原材料', // 存货类别 名称
  defaulttax: 'SL02_SYS', // 默认税率
  defaulttaxName: '13%增值税', // 默认税率 名称
  materialattr: '1', // 物料属性
  materialattrName: '外购', // 物料属性 名称
  currency: 'PRE001', // 币别
  batchmanage: '1', // 批号管理
  assets: '0', // 允许资产
  onlocklib: '1', // 允许锁库
  onreturn: '1', // 允许退货
  onreturnmaterial: '1', // 允许退料
  product: '0', // 允许生产
  canBeMainProduct: '0', // 可为主产品  默认否
  allowprocurement: '1', // 允许采购
  inventory: '1', // 允许库存
  sales: '1', // 允许销售
  outcommit: '0', // 允许委外
  pricestate: '1', // 影响价格
  coststate: '1', // 影响成本
  mallsales: '0', // 商城可售
  onshelf: '1', // 商城上架
  isFreeShipping: '1', // 包邮
  isOverLength: '0', // 超长
  // picMatch: `1`, // 图片匹配度
  deliveryday: '', // 发货日
  deliveryDate: '',
  orderQuantity: '', // 起订量
}

// 路由参数
interface RouteParam extends nowpagesparam {
  init?: boolean // 是否初始化
  copydata?: any // copy
  type?: string
}

const Goodsdetail = () => {
  const {
    usehookstate,
    form,
    platform_form,
    changeList,
    setChangeList,
    onChangePic,
    onChangeAptitude,
    onChangeDetailPic,
    onChangeCate,
    onChangeBrandSale,
    onClickClose,
    onCancelrecord,
    getformatFormFields,
    reloaddata,
    tempCode,
    onChangeDelivery,
    getTempCode,
    setMaterialType,
    onChangeMaterialType,
    changeItemList,
    handleOpenExtractModal,
    closeExtractModal,
    onFieldsChange,
    externalLinkList,
    setExternalLinkList,
    setQualityDataList,
    checkProductForbidChar,
    checkTaxCodeBlacklist,
    setPreCheckErrors,
    setReportFieldConfigList,
    relateFieldKeySet,
    handleRelateFieldBlur,
  } = useHook()
  const [pagesstate, dispatch] = useReducer(reducer, defaultState)
  const dispatchRedux = useDispatch()
  const {
    pictures,
    qualDocFileList,
    requiredAttachTypes,
    frontendHintText,
    detailPic,
    productCode,
    fieldList,
    isRecord,
    loadingPage,
    hasDelivery,
    unitDisabled,
    materialType,
    itemsList,
    qualityDataList,
    preCheckErrors,
  } = usehookstate
  const { isloading } = pagesstate
  const { tempId, childId } = pagesstate.currentparam
  const { role, cooperateType } = useTypedSelector((state) => state.authtoken)
  const { pagekey } = useTypedSelector((state) => state.pageCache)
  const location = useLocation<RouteParam>()

  const { state } = location

  useEffect(() => {
    const flag = getpagecache()
    if (flag && !state) {
      // 读取缓存的公共模块状态
      reloaddata(flag.commonState)
      // 设置form数据
      form.setFieldsValue(flag.formState)
      // 读取缓存的当前模块状态
      dispatch(reloadDataAction(flag.pageState))
      // 判断物料属性
      materialattrDisabled(flag.pageState.currentparam.BtnState)
    } else if (state) {
      // 初始化 formstate
      dispatchRedux(setformStateInitAction())
      materialattrDisabled(state.BtnState)
      if (state.type === 'copy') {
        return
      }
      // 新增物料
      if (!tempId && !childId) {
        isAddMethod(state.selectTreeData)
        GET_PRODUCT_CACHE().then((res) => {
          getTempCode()
          if (res.code == 0) {
            if (res.data?.content) {
              const data = JSON.parse(res.data?.content)
              if (!data.pageState) {
                return
              }
              reloaddata(data.pageState)
              setChangeList(!changeList)
              form.setFieldsValue(data.formData)
              platform_form.setFieldsValue(data.platformForm)
              setExternalLinkList(data.externalLinks || [])
            }
          }
        })
      }
      if (state.BtnState?.includes('Add')) {
        // 新增物料，物料类型取默认值
        setMaterialType(cooperateType === '3' ? '2' : cooperateType)
      }
      form.setFieldsValue({ childId: state.childId }) // 设置物料id 如果为新增则是空 用于maininfo页面判断
    }
    // eslint-disable-next-line
  }, [])

  useEffect(() => {
    // 缓存存数据
    const pathName = history.location.pathname + 'goodsDetail'
    const formstate = form.getFieldsValue()
    const action = setModuleDataAction({
      key: pathName,
      data: {
        commonState: usehookstate, // 公共状态
        pageState: pagesstate, // 当前状态
        formState: formstate,
      },
    })
    dispatchRedux(action)
    return () => {
      const formstate = form.getFieldsValue()
      const action = setModuleDataAction({
        key: pathName,
        data: {
          commonState: usehookstate, // 公共状态
          pageState: pagesstate, // 当前状态
          formState: formstate,
        },
      })
      dispatchRedux(action)
    }
    // eslint-disable-next-line
  }, [usehookstate, pagesstate])

  const handleLinkChange = (newList: ExternalLinkType[]) => {
    setExternalLinkList(newList)
  }

  // 获取数据
  const getpagecache = () => {
    const pathName = history.location.pathname + 'goodsDetail'
    const data = pagekey.filter((item) => item.key === pathName)
    if (data.length === 1) {
      return data[0].data
    }
    return null
  }

  // 物料属性是否可修改
  const materialattrDisabled = (params?: MaterialDetailType[]) => {
    let flag = false
    if (role === RoleType.SOURCE_PURCHASE_MAN && params) {
      // 采购员 物料属性
      flag = params.indexOf('Add') !== -1 ? false : true
    }
    dispatchRedux(setformStateAction([{ key: 'materialattr', disabled: flag }]))
  }

  // 是否 添加物料方法
  async function isAddMethod(cate?: treeType) {
    // 有类目id 设置前缀编码 和 扩展属性
    if (cate) {
      onChangeCate(cate.id)
      // 设置类目id和名称
      form.setFieldsValue({
        catoyName: cate.title,
        catoyid: cate.id,
      })
    }

    dispatchRedux(
      setformStateAction([{ key: 'catoyid', hidden: false, disabled: false }]),
    )
    // 设置货主 物料默认数据
    form.setFieldsValue({
      ...defaultFormData,
    })
  }

  // 提交数据 立即提交 暂存
  async function preCheckSubmit(params: ProductChildParams) {
    setPreCheckErrors({})
    // 使用预审 Hook 处理提交逻辑
    await executePreCheck(
      params,
      preReviewOfMaterialsTypeEnum.getValueByLabel('新增物料') || '',
    )
  }
  // 使用预审 Hook
  const { executePreCheck, PreCheckModalComponent } = usePreCheck({
    form,
    onSubmit: onCommit,
    onModify: (errors) => {
      if (Number(errors.sugMallPrice) > 0 && itemsList.length > 0) {
        const mallFieldKey = itemsList[0].itemFields.find(
          (item) => item?.fieldMeaning === 'mallPrice',
        )?.fieldKey
        if (mallFieldKey) {
          platform_form.setFieldsValue({
            [`${itemsList[0].code}_${mallFieldKey}`]: errors.sugMallPrice,
          })
        }
      }
      setPreCheckErrors(errors)
    },
  })

  // 提交新增物料 暂存物料提交 数据
  async function onSubmmit(operateType: string) {
    try {
      // 格式化表单数据
      const values = await getformatFormFields()
      const canPassForbidCharCheck = await checkProductForbidChar(values)
      if (!canPassForbidCharCheck) {
        return
      }

      // 提交前校验税编是否命中当前货主的黑名单。货主由 MPM 按物料类型推导，
      // 这里只把 productType 传过去，不在前端算货主，避免两端口径走偏
      const canPassBlacklistCheck = await checkTaxCodeBlacklist(
        values.productType,
        values.taxCategoryCode,
      )
      if (!canPassBlacklistCheck) {
        return
      }

      if (
        !itemsList.length &&
        materialTypeEnum.getLabelByValue(values.productType) ===
          '电商供应商物料'
      ) {
        message.error('电商供应商物料至少添加一个关联项目')
        return
      }
      const params: any = {
        ...values,
        tempCode: tempCode, // 临时CODE
        saveType: operateType, // 必须 操作类型；1、提交 2、暂存
        productMdmId: '',
        externalLinks: toExternalLinkPayload(externalLinkList),
      }
      if ((!childId && !tempId) || (tempId && !childId)) {
        // 校验品牌型号问题
        preCheckSubmit(params)
      } else {
        // 直接提交
        preCheckSubmit(params)
      }
    } catch (errorInfo) {
      const errorFields = (errorInfo as any)?.errorFields
      const error = errorFields?.[0]?.errors?.[0]
      console.error(errorInfo)
      if (errorFields && error) {
        message.warning(error)
        const errorname = errorFields?.[0]?.name
        // 返回报错信息，滚动到第一个报错的位置
        form.scrollToField(errorname?.toString(), { behavior: 'smooth' })
      }
    }
  }

  // 实际提交物料的函数
  async function onCommit(params: ProductChildParams) {
    dispatch(setChangeLoading(true))
    const msg = '提交中'
    message.loading(msg, 0)
    const resData = await ADD_PRODUCTCHILD(params)
    dispatch(setChangeLoading(false))
    if (resData.code === 0) {
      if (childId) {
        message.success('已提交')
      } else {
        message.success('已成功')
      }
      reportProjectCategoryAdoptions()
      // 关闭弹窗，回退路由
      onClickClose(history.location.pathname + 'goodsDetail')
      history.push({
        pathname: `${SUPROUTE}/submitResult`,
        state: {
          data: [params],
        },
      })
    } else {
      message.destroy()
    }
  }

  // 点击保存
  async function onSave() {
    try {
      // 格式化表单数据
      const values = form.getFieldsValue()
      const platformForm = platform_form.getFieldsValue()
      message.loading('保存中', 0)
      const resData = await CACHE_PRODUCT({
        formData: values,
        platformForm,
        pageState: usehookstate,
        externalLinks: toExternalLinkPayload(externalLinkList),
      })
      if (resData.code === 0) {
        if (childId) {
          message.success('已提交')
        } else {
          message.success('已成功')
        }
        reportProjectCategoryAdoptions()
        // 关闭页面，回退路由
        onClickClose()
      } else {
        message.destroy()
      }
    } catch (errorInfo) {
      const error = (errorInfo as any).errorFields[0].errors[0]
      message.warning(error)
      const errorname = (errorInfo as any).errorFields[0].name
      // 返回报错信息，滚动到第一个报错的位置
      form.scrollToField(errorname.toString(), { behavior: 'smooth' })
    }
  }

  // 按钮类型
  const ButtonComponents = () => {
    let EditBtn = null
    EditBtn = (
      <Button
        type="link"
        size="small"
        loading={isloading}
        onClick={() => onSubmmit('1')}
      >
        提交
      </Button>
    )
    return (
      <div className={Style.btnbox}>
        <div className={Style['btn-left-box']}></div>
        <div className={Style['btn-center-box']}></div>
        <div className={Style['btn-right-box']}>
          <Space>
            <Button type="link" size="small" onClick={onSave}>
              保存
            </Button>
            {EditBtn}
            <Button type="link" size="small" onClick={onClickClose}>
              关闭
            </Button>
          </Space>
        </div>
      </div>
    )
  }

  return (
    <Form.Provider>
      <ButtonComponents />
      <div className={Style.container}>
        <div className={Style.box}>
          <Skeleton loading={loadingPage} active>
            <MaterialType
              form={form}
              setMaterialType={setMaterialType}
              onChange={onChangeMaterialType}
              type="single"
              onFieldsChange={onFieldsChange}
            />
          </Skeleton>
        </div>
        <div className={Style.box}>
          <div
            className={Style.boxtitle}
            style={{ display: 'flex', justifyContent: 'space-between' }}
          >
            <span>主要信息</span>
            <span
              style={{
                display: 'inline-block',
                marginRight: '24px',
                fontWeight: 'normal',
                color: '#3C44D3',
                cursor: 'pointer',
                userSelect: 'none',
              }}
              onClick={() => handleOpenExtractModal('extract')}
            >
              🔥快捷拾取
            </span>
          </div>
          <Divider style={{ margin: '0' }} />
          <Skeleton loading={loadingPage} active>
            <Maininfo
              form={form}
              onChangeCate={onChangeCate}
              onChangeSale={onChangeBrandSale}
              tempCode={tempCode}
              showUnitTip
              unitDisabled={unitDisabled}
              getTempCode={getTempCode}
              materialType={materialType}
              onFieldsChange={onFieldsChange}
              preCheckErrors={preCheckErrors}
            />
          </Skeleton>
        </div>
        <div className={Style.box}>
          <div className={Style.boxtitle}>
            <span>次要信息</span>
          </div>
          <Divider style={{ margin: '0' }} />
          <Skeleton loading={loadingPage} active>
            <Secondaryinfo
              form={form}
              onChangeDelivery={onChangeDelivery}
              hasDelivery={hasDelivery}
              onFieldsChange={onFieldsChange}
            />
          </Skeleton>
        </div>
        {(materialType === '1' || materialType === '2') && (
          <div className={Style.box}>
            <div className={Style.boxtitle}>
              <span>关联项目信息</span>
              {materialTypeEnum.getLabelByValue(
                form.getFieldValue('productType'),
              ) === '电商供应商物料' && (
                <span style={{ color: '#ff4d4f', marginLeft: 10 }}>
                  * 请至少添加一个关联项目
                </span>
              )}
            </div>
            <Divider style={{ margin: '0' }} />
            <Skeleton loading={loadingPage} active>
              <AssociationItems
                form={platform_form}
                normalForm={form}
                itemsList={itemsList}
                changeItemList={changeItemList}
                changeList={changeList}
                onFieldsChange={onFieldsChange}
                qualityDataList={qualityDataList}
                setQualityDataListAction={setQualityDataList}
                preCheckErrors={preCheckErrors}
                reportingType="NEW"
                onReportConfigChange={setReportFieldConfigList}
                relateFieldKeySet={relateFieldKeySet}
                onRelateFieldBlur={handleRelateFieldBlur}
              />
            </Skeleton>
          </div>
        )}
        <div className={Style.box}>
          <div className={Style.boxtitle}>
            <span>拓展属性</span>
            <span className={Style.tips}>
              拓展属性标题为<span className={Style.blueTip}>蓝色</span>
              代表有平台项目对该拓展属性有要求，鼠标移到拓展属性标题即可查看具体平台项目。
              <span
                style={{
                  color: '#8C8C8C',
                  fontSize: '12px',
                  lineHeight: '24px',
                }}
              >
                都需填写，无法填写的填/【如果是大批量无法填写，可能是四级类目选错】
              </span>
            </span>
          </div>
          <Divider style={{ margin: '0' }} />
          <Skeleton loading={loadingPage} active>
            <Expandattr
              form={form}
              fieldList={fieldList}
              itemsList={itemsList}
              frontendHintText={frontendHintText}
              onFieldsChange={onFieldsChange}
            />
          </Skeleton>
        </div>
        <div className={Style.box}>
          <Divider style={{ margin: '0' }} />
          <AptitudeAttach
            dataSource={qualDocFileList}
            onChange={onChangeAptitude}
            productCode={productCode}
            loading={loadingPage}
            requiredAttachTypes={requiredAttachTypes}
          />
        </div>
        <div className={Style.box}>
          <div className={Style.boxtitle}>
            <span>外部链接/价格佐证</span>
          </div>
          <Divider style={{ margin: '0' }} />
          <Skeleton loading={loadingPage} active>
            <ExternalLink
              form={form}
              externalLinkList={externalLinkList}
              onLinkChange={handleLinkChange}
            />
          </Skeleton>
        </div>
        <div className={Style.box}>
          <div className={Style.boxtitle}>
            <span>图文信息</span>
            <span
              style={{
                display: 'inline-block',
                margin: ' 0 24px',
                fontWeight: 'normal',
                color: '#3C44D3',
                cursor: 'pointer',
                userSelect: 'none',
              }}
              onClick={() => handleOpenExtractModal('pic')}
            >
              🔥链接取图
            </span>
            <span>支持类型：.bmp|\.gif|\.jpg|\.png|\.webp|\.heic</span>
          </div>
          <Divider style={{ margin: '0' }} />
          <Skeleton loading={loadingPage} active>
            <div className={Style.picinfobox}>
              {/* <div className={Style.picinfotitle}>
                <span className={Style.text}>图片关系</span>
              </div> */}
              {/* true 显示 匹配、类似 注意必填校验 */}
              <Mainpic required form={form} onFieldsChange={onFieldsChange} />
              <div className={Style.picinfotitle}>
                <span className={Style.text}>
                  主图：
                  <span
                    style={{
                      color: '#8C8C8C',
                      fontSize: '14px',
                      lineHeight: '24px',
                    }}
                  >
                    尺寸：800×800 px。建议上传3张及以上，最多20张。第一张白底，其它尽量白底。主图要求颜色唯一，需要与描述或者拓展属性值一致【最低标准∶不低于在其他平台上架的标准】
                  </span>
                </span>
              </div>
              {preCheckErrors?.picturesError && (
                <div
                  style={{
                    color: '#FF7D00',
                    fontSize: '14px',
                    lineHeight: '24px',
                  }}
                >
                  {preCheckErrors?.picturesError}
                </div>
              )}
              <Uploadimg
                dataSource={pictures}
                onChange={onChangePic}
                tempCode={tempCode}
                maxCount={20}
                fileType={'.bmp,.gif,.jpg,.png,.webp,.heic'}
                dragable
                aiEdit
              />
              {/* true 显示 可用、不可用 注意必填校验 */}
              <div hidden>
                <Originalpic
                  required={false}
                  form={form}
                  onFieldsChange={onFieldsChange}
                />
              </div>
              <div className={Style.picinfotitle}>
                <span className={Style.text}>
                  详情图：
                  <span
                    style={{
                      color: '#8C8C8C',
                      fontSize: '12px',
                      lineHeight: '24px',
                    }}
                  >
                    上传图片宽度不小于500 px，高度不限，最多100张。要图文丰富，需包含产品图、细节图、参数图、使用场景图，【最低标准:不低于在其他平台上架的标准】。一定不能包含:7天无理由退换货、送货上门、免费开票、水印、其它店铺信息、质保、包邮、链接、二维码、电话号码......等敏感词汇
                  </span>
                </span>
              </div>
              {preCheckErrors?.detailsPicturesError && (
                <div
                  style={{
                    color: '#FF7D00',
                    fontSize: '14px',
                    lineHeight: '24px',
                  }}
                >
                  {preCheckErrors?.detailsPicturesError}
                </div>
              )}
              <Uploadimg
                dataSource={detailPic}
                onChange={onChangeDetailPic}
                tempCode={tempCode}
                isDetailPic
                fileType={'.bmp,.gif,.jpg,.png,.webp,.heic'}
                maxCount={100}
                dragable
                aiEdit
              />
            </div>
          </Skeleton>
        </div>

        <CustomModal
          title="操作记录"
          open={isRecord}
          modalCancel={onCancelrecord}
          footer={false}
        >
          <Record type={1} id={childId} />
        </CustomModal>
      </div>
      {/* 拾贝快捷拾取弹框 */}
      <ShibeiModal
        form={form}
        hookstate={usehookstate}
        onChangePic={onChangePic}
        onChangeDetailPic={onChangeDetailPic}
        closeExtractModal={closeExtractModal}
      ></ShibeiModal>
      {/* 物料预审弹框 */}
      {PreCheckModalComponent}
    </Form.Provider>
  )
}

export default Goodsdetail

type MaterialDetailType =
  // 新增
  | 'Add'
  // 编辑
  | 'Edit'
  // 详情
  | 'Detail'
  // 禁用
  | 'Disable'
  // 启用
  | 'Undisable'
  // 复制
  | 'Copy'
